import React, { memo } from "react";
import { CardItem } from "types/types";
import {
  Card,
  CardBadge,
  CardHeader,
  CardTitle,
  Circle,
  DeleteIcon,
  InfoRowWrapper,
  InfoText,
} from "./styles";
import { capitalizeFirstLetter } from "utils/helpers";

interface ConfigurationCardProps {
  item: CardItem;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

interface InfoRowProps {
  label: React.ReactNode;
}
const InfoRow: React.FC<InfoRowProps> = memo(({ label }) => (
  <InfoRowWrapper>
    <Circle />
    <InfoText>{label}</InfoText>
  </InfoRowWrapper>
));

export const ConfigurationCard: React.FC<ConfigurationCardProps> = ({
  item,
  onEdit,
  onDelete,
}) => {
  return (
    <Card onClick={() => onEdit(item.id)}>
      <CardHeader>
        <CardTitle>{item.title}</CardTitle>
        <DeleteIcon
          onClick={(e) => {
            e.stopPropagation();
            onDelete(item.id);
          }}
        />
      </CardHeader>
      <InfoRow
        label={
          <>
            Automation target:{" "}
            <CardBadge $badgeType={item.type}>
              {capitalizeFirstLetter(item.type)}
            </CardBadge>
          </>
        }
      />
      <InfoRow
        label={
          <>
            Niche: <strong>{capitalizeFirstLetter(item.niche)}</strong>
          </>
        }
      />
      <InfoRow
        label={
          <>
            Language: <strong>{capitalizeFirstLetter(item.language)}</strong>
          </>
        }
      />
      {item.type === "article" && item.targetPlugin && (
        <InfoRow
          label={
            <>
              Target SEO plugin: <strong>{item.targetPlugin}</strong>
            </>
          }
        />
      )}
    </Card>
  );
};
